import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Alert,
} from '@mui/material';
import { useChangePasswordMutation } from '../api/JsdhNotifikaceService/service/AuthMutation';

interface ChangePasswordDialogProps {
    open: boolean;
    onClose: () => void;
}

const ChangePasswordDialog: React.FC<ChangePasswordDialogProps> = ({ open, onClose }) => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [validationError, setValidationError] = useState<string | null>(null);

    const changePasswordMutation = useChangePasswordMutation();

    const resetForm = () => {
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setValidationError(null);
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setValidationError(null);

        // Validace
        if (!oldPassword || !newPassword || !confirmPassword) {
            setValidationError('Všechna pole jsou povinná.');
            return;
        }

        if (newPassword.length < 8) {
            setValidationError('Nové heslo musí mít alespoň 8 znaků.');
            return;
        }

        if (newPassword !== confirmPassword) {
            setValidationError('Nové heslo a potvrzení se neshodují.');
            return;
        }

        if (oldPassword === newPassword) {
            setValidationError('Nové heslo musí být odlišné od starého.');
            return;
        }

        changePasswordMutation.mutate(
            { oldPassword, newPassword },
            {
                onSuccess: () => {
                    handleClose();
                },
            }
        );
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <form onSubmit={handleSubmit}>
                <DialogTitle>Změna hesla</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={2} mt={1}>
                        {validationError && (
                            <Alert severity="error">{validationError}</Alert>
                        )}
                        <TextField
                            label="Současné heslo"
                            type="password"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            fullWidth
                            required
                            autoComplete="current-password"
                        />
                        <TextField
                            label="Nové heslo"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            fullWidth
                            required
                            autoComplete="new-password"
                            helperText="Minimálně 8 znaků"
                        />
                        <TextField
                            label="Potvrzení nového hesla"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            fullWidth
                            required
                            autoComplete="new-password"
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} disabled={changePasswordMutation.isPending}>
                        Zrušit
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={changePasswordMutation.isPending}
                    >
                        {changePasswordMutation.isPending ? 'Ukládám...' : 'Změnit heslo'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default ChangePasswordDialog;
